<template>
  <v-card :loading="loading" class="pa-4" flat>
    <v-alert
      v-model="dismissed"
      type="warning"
      dense
      outlined
      color="amber darken-1"
      border="left"
      class="mb-4 text-body-2"
      icon="mdi-information-outline"
    >
      نکته:<br />
      بدون انتخاب بازه، در حالت روزانه داده‌های یک سال اخیر نمایش داده
      می‌شود.<br />
      برای بازه‌های طولانی، نمودار دایره‌ای/دونات پیشنهاد می‌شود. <br />در
      حالت‌های هفتگی، ماهانه و سالانه محدودیتی وجود ندارد.
    </v-alert>
    <!-- بخش فیلترها -->
    <v-card-actions class="mb-6 d-block px-0">
      <!-- دکمه نمایش/مخفی کردن فیلترها فقط در موبایل -->
      <v-btn
        class="d-sm-none mb-3 rounded-lg"
        block
        outlined
        color="primary"
        @click="mobileFiltersExpanded = !mobileFiltersExpanded" 
      >
        <v-icon left>{{ mobileFiltersExpanded ? 'mdi-chevron-up' : 'mdi-filter-variant' }}</v-icon>
        {{ mobileFiltersExpanded ? 'بستن فیلترها' : 'نمایش فیلترها و تنظیمات' }}
      </v-btn>

      <v-expand-transition>
        <div v-show="$vuetify.breakpoint.smAndUp || mobileFiltersExpanded" class="w-100 px-2 px-sm-0">
          <v-row align="center" dense>
            <v-col cols="12" sm="auto">
              <v-btn class="btn-upload rounded-lg" @click="showAllCharts" outlined block>
                <v-icon left>mdi-eye</v-icon> نمایش همه نمودارها
              </v-btn>
            </v-col>

            <v-col cols="12" sm="4" md="3" class="mr-sm-2">
              <v-select
                v-model="selectedChartType"
                :items="chartType"
                dense
                outlined
                hide-details
                label="نوع نمودار"
                @change="updateActiveCharts"
              >
                <template v-slot:item="{ item }">
                  <v-icon class="me-2">{{ item.icon }}</v-icon> {{ item.text }}
                </template>
              </v-select>
            </v-col>

            <v-col cols="12" sm="4" md="3" class="mr-sm-2">
              <v-select
                v-model="selectedPreview"
                :items="previewType"
                dense
                outlined
                hide-details
                label="حالت نمایش"
                @change="updateActiveCharts"
              />
            </v-col>

            <v-spacer class="d-none d-md-block"></v-spacer>

            <v-col cols="12" sm="auto">
              <v-switch
                v-model="lableToggler"
                label="لیبل‌ها"
                hide-details
                class="mt-0 pt-0"
                @change="updateActiveCharts"
              />
            </v-col>
          </v-row>
        </div>
      </v-expand-transition>
    </v-card-actions>

<v-btn
  class="d-sm-none mb-4 rounded-lg"
  block
  outlined
  color="secondary"
  @click="mobileChartsExpanded = !mobileChartsExpanded"
>
  <v-icon left>{{ mobileChartsExpanded ? 'mdi-chevron-up' : 'mdi-chart-box-outline' }}</v-icon>
  {{ mobileChartsExpanded ? 'بستن نمودارها' : 'نمایش نمودارها' }}
</v-btn>

<!-- بدنه نمودارها -->
<v-expand-transition>
  <div v-show="$vuetify.breakpoint.smAndUp || mobileChartsExpanded">
    <v-row cols="12">
      <v-col
        v-for="item in statCards"
        :key="item.value"
        cols="12"
        md="6"
        lg="4"
      >
        <v-card
          outlined
          class="fill-height d-flex flex-column pa-2 rounded-lg"
          draggable
        >
          <v-card-title class="text-subtitle-1">
            <v-avatar size="36" :color="item.color + ' lighten-5'" class="me-3">
              <v-icon small :color="item.color">{{ item.icon }}</v-icon>
            </v-avatar>
            {{ item.text }}
            <v-spacer></v-spacer>
            <v-btn
              small
              :class="item.active ? 'btn-delete' : 'btn-upload'"
              class="rounded-lg"
              @click="toggleCard(item)"
              :loading="item.loading"
            >
              <v-icon small>{{
                item.active ? "mdi-close" : "mdi-chart-bar"
              }}</v-icon>
              {{ item.active ? "بستن" : "نمایش نمودار" }}
            </v-btn>
          </v-card-title>

          <v-divider v-if="item.active"></v-divider>

          <v-card-text class="flex-grow-1">
            <div
              v-show="item.active"
              :ref="'chart-' + item.value"
              style="min-height: 250px"
            ></div>

            <div
              v-if="!item.active"
              class="d-flex flex-column align-center justify-center py-10 grey--text"
            >
              <v-icon size="48" color="grey lighten-2"
                >mdi-chart-box-outline</v-icon
              >
              <span>برای مشاهده آمار کلیک کنید</span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
import moment from "moment-jalaali";
import ApexCharts from "apexcharts";

export default {
  name: "QrStatistics",
  props: {
    filter: String,
    selectedType: String,
    range: Object,
  },
  data() {
    return {
      mobileChartsExpanded: false, 
      mobileFiltersExpanded: false, 
      dismissed: false,
      loading: false,
      selectedChartType: "pie",
      selectedPreview: "number",
      lableToggler: true,
      charts: {},

      statCards: [
        {
          value: "hardware",
          text: "سخت‌افزار",
          icon: "mdi-desktop-tower",
          color: "blue",

          active: false,
          loading: false,
        },
        {
          value: "os",
          text: "سیستم‌عامل",
          icon: "mdi-microsoft-windows",
          color: "purple",
          active: false,
          loading: false,
        },
        {
          value: "osv",
          text: "نسخه سیستم‌عامل",
          icon: "mdi-tag-outline",
          color: "teal",
          active: false,
          loading: false,
        },
        {
          value: "browser",
          text: "مرورگر",
          icon: "mdi-web",
          color: "orange",
          active: false,
          loading: false,
        },
        {
          value: "browser_version",
          text: "نسخه مرورگر",
          icon: "mdi-numeric",
          color: "indigo",
          active: false,
          loading: false,
        },
        {
          value: "country",
          text: "کشور",
          icon: "mdi-earth",
          color: "green",
          active: false,
          loading: false,
        },
      ],
      chartType: [
        {
          value: "line",
          text: "نمودار خطی",
          type: "normal",
          icon: "mdi-chart-line",
        },
        {
          value: "area",
          text: "نمودار سطحی",
          type: "normal",
          icon: "mdi-chart-areaspline-variant",
        },
        {
          value: "bar",
          text: "نمودار میله‌ای",
          type: "normal",
          icon: "mdi-chart-bar",
        },
        {
          value: "radar",
          text: "نمودار راداری",
          type: "normal",
          icon: "mdi-radar",
        },
        {
          value: "heatmap",
          text: "نمودار حرارتی",
          type: "normal",
          icon: "mdi-thermometer",
        },
        {
          value: "pie",
          text: "نمودار پای",
          type: "radial",
          icon: "mdi-chart-pie",
        },
        {
          value: "donut",
          text: "نمودار دونات",
          type: "radial",
          icon: "mdi-chart-donut",
        },
      ],
      previewType: [
        { value: "number", text: "عددی", icon: "mdi-numeric" },
        { value: "percent", text: "درصدی", icon: "mdi-percent" },
      ],
      selectedPreview: "number",
      lableToggler: true,
      filters: [
        {
          index: 1,
          value: "d",
          text: "روزانه",
        },
        {
          index: 2,
          value: "w",
          text: "هفتگی",
        },
        {
          index: 3,
          value: "m",
          text: "ماهانه",
        },
        {
          index: 4,
          value: "y",
          text: "سالانه",
        },
      ],
      type: [
        {
          value: "all",
          text: "همه",
        },
        {
          value: "unique",
          text: "یکتا",
        },
      ],
    };
  },

  watch: {
    selectedChartType(newVal) {
      if (!["pie", "dount"].includes(newVal) && this.filter === "d") {
        this.dismissed = true;
      } else this.dismissed = false;
    },

    filter: "updateActiveCharts",
    selectedType: "updateActiveCharts",
    range: { deep: true, handler: "updateActiveCharts" },
  },

  methods: {
    parseToMoment(raw, filter) {
      switch (filter) {
        case "d":
          // YYYY-MM-DD
          return moment(raw, "YYYY-MM-DD");

        case "w": {
          // YYYY-Www
          const [year, week] = raw.split("-W");
          return moment().year(Number(year)).week(Number(week)).startOf("week");
        }

        case "m":
          // YYYY-MM-01
          return moment(raw, "YYYY-MM-DD").startOf("month");

        case "y":
          // YYYY-01-01
          return moment(raw, "YYYY-MM-DD").startOf("year");

        default:
          return moment.invalid();
      }
    },

    /**
     * ساخت label شمسی نهایی برای x-axis
     */
    getShamsiLabel(m, filter) {
      if (!m || !m.isValid()) return "-";

      switch (filter) {
        case "y":
          return m.format("jYYYY");

        case "m":
          return `${m.format("jM")}-${m.format("jYYYY")}`;

        case "w":
          return `هفته ${m.week()}-${m.format("jYYYY")}`;

        case "d":
          return m.format("jYYYY-jMM-jDD");

        default:
          return m.format("jYYYY-jMM-jDD");
      }
    },

    async asyncLoadChart() {
      const chartConfig = this.chartType.find(
        (item) => item.value === this.selectedChartType,
      );
      if (!chartConfig) return;

      for (const { key, value } of this.statisticsItems) {
        if (!this.$refs[key] || !this.$refs[key][0]) continue;

        const item = this.statisticsItems.find((i) => i.key === key);
        if (item) item.loading = true;

        const chartElement = this.$refs[key][0];

        const options =
          chartConfig.type === "radial"
            ? this.radialChart(key, value)
            : this.normalChart(key, value);

        const chart = new ApexCharts(chartElement, options);
        await chart.render();
        this.charts.push(chart);

        if (item) item.loading = false;
      }
    },

    normalChart(dataType, dataObject) {
      const rawLabelsSet = new Set();
      const series = [];

      // ۱. استخراج تمام تاریخ‌های موجود در کل دیتا برای محور X
      Object.values(dataObject).forEach((items) => {
        items.forEach((item) => {
          if (item?.data) rawLabelsSet.add(item.data);
        });
      });

      // ۲. مرتب‌سازی تاریخ‌ها (شمسی/میلادی فرقی نمی‌کند، بر اساس تایم‌استمپ)
      const sortedLabels = Array.from(rawLabelsSet)
        .map((raw) => {
          const m = this.parseToMoment(raw, this.filter);
          return {
            raw,
            moment: m,
            ts: m.isValid() ? m.valueOf() : 0,
          };
        })
        .sort((a, b) => a.ts - b.ts);

      // ۳. تولید لیبل‌های نهایی برای نمایش در نمودار
      const formattedLabels = sortedLabels.map((l) =>
        this.getShamsiLabel(l.moment, this.filter),
      );

      // ۴. نگاشت داده‌ها برای هر سری (مثلاً Chrome، Firefox و ...)
      Object.entries(dataObject).forEach(([key, values]) => {
        let name = key;

        if (dataType === "browser_version") name = values[0]?.os + ": " + key;
        else if (dataType === "osv")
          name = this.osTranslate(values[0]?.os) + ": " + key;
        else if (dataType === "os") name = this.osTranslate(name);
        else if (dataType === "country") name = this.countryTranslate(key);
        else if (dataType === "hardware") name = this.platformTranslate(name);

        const dataMap = {};
        values.forEach((v) => {
          dataMap[v.data] = v.count;
        });

        series.push({
          name,
          data: sortedLabels.map((l) => dataMap[l.raw] ?? 0),
        });
      });

      return {
        ...this.options,
        chart: {
          ...this.options.chart,
          type: this.selectedChartType,
          fontFamily: "Vazir, Tahoma",
        },
        xaxis: {
          ...this.options.xaxis,
          type: "category",
          categories: formattedLabels,

          labels: {
            rotate: -30,
            trim: true,
          },
        },
        series,
      };
    },

    getFormattedName(dataType, key, firstItem) {
      switch (dataType) {
        case "browser_version":
          return `${firstItem?.os || ""}: ${key}`;
        case "osv":
          return `${this.osTranslate(firstItem?.os || "")}: ${key}`;
        case "os":
          return this.osTranslate(key);
        case "country":
          return this.countryTranslate(key);
        case "hardware":
          return this.platformTranslate(key);
        default:
          return key;
      }
    },
    async toggleCard(item) {
      item.active = !item.active;
      if (item.active) {
        await this.loadSingleChart(item);
      } else {
        this.destroyChart(item.value);
      }
    },

    async loadSingleChart(item) {
      item.loading = true;
      try {
        const params = this.$route.fullPath.includes("qr/statistics2")
          ? {
              identifier: this.$route.params.name || "",
              filters: this.filter,
              type: this.selectedType,
              data_type: item.value,
              start_at: this.range?.startAt,
              end_at: this.range?.endAt,
              chart: this.selectedChartType,
            }
          : {
              domain: this.$route.params.name + "/",
              identifier: this.$route.params.id || "",
              filters: this.filter,
              type: this.selectedType,
              data_type: item.value, // ارسال نوع دیتای خاص کارت
              start_at: this.range?.startAt,
              end_at: this.range?.endAt,
              chart: this.selectedChartType,
            };

        const response = await this.$api.get("v1/testQr/statistics", {
          params,
        });
        const rawData = response.data.data[item.value];
        const hasData =
          rawData &&
          ((Array.isArray(rawData) && rawData.length > 0) ||
            (typeof rawData === "object" && Object.keys(rawData).length > 0));
        if (hasData) {
          await this.renderChart(item.value, rawData);
        } else {
          this.$modal.info(
            "اطلاع رسانی",
            "هنوز بازدیدی از کیوار شما ثبت نشده است. ",
          );
        }
      } catch (error) {
        this.$modal.error("خطا", `بارگیری داده‌های ${item.text} شکست خورد`);
        item.active = false;
      } finally {
        item.loading = false;
      }
    },
    async renderChart(key, data) {
      this.destroyChart(key);
      await this.$nextTick();

      const element = this.$refs[`chart-${key}`][0];
      if (!element) return;

      let processedData = data;

      if (["osv", "browser", "browser_version"].includes(key) && data[""]) {
        const flatArray = data[""];
        processedData = {};

        flatArray.forEach((item) => {
          const groupValue = item[key] || "unknown";
          if (!processedData[groupValue]) {
            processedData[groupValue] = [];
          }
          processedData[groupValue].push(item);
        });
      }

      const chartConfig = this.chartType.find(
        (t) => t.value === this.selectedChartType,
      );
      const isRadial = chartConfig && chartConfig.type === "radial";

      let options = {};

      if (isRadial) {
        const labels = [];
        const series = [];

        Object.entries(processedData).forEach(([name, values]) => {
          labels.push(this.translateValue(key, name));
          const totalCount = values.reduce((sum, v) => sum + v.count, 0);
          series.push(totalCount);
        });

        options = {
          chart: {
            type: this.selectedChartType,
            height: 300,
            fontFamily: "Vazir",
          },
          labels: labels,
          series: series,
          dataLabels: { enabled: this.lableToggler },
          legend: { position: "bottom" },
        };
      } else {
        const allDatesSet = new Set();
        const series = [];

        Object.values(processedData).forEach((items) => {
          items.forEach((i) => {
            if (i.data) allDatesSet.add(i.data);
          });
        });

        const sortedDates = Array.from(allDatesSet)
          .map((raw) => {
            const m = this.parseToMoment(raw, this.filter);
            return { raw, moment: m, ts: m.isValid() ? m.valueOf() : 0 };
          })
          .sort((a, b) => a.ts - b.ts);

        const formattedLabels = sortedDates.map((l) =>
          this.getShamsiLabel(l.moment, this.filter),
        );

        Object.entries(processedData).forEach(([name, values]) => {
          let labelName = name;
          if (key === "browser_version")
            labelName = (values[0]?.os || "") + ": " + name;
          else if (key === "osv")
            labelName = this.osTranslate(values[0]?.os || "") + ": " + name;
          else if (key === "os") labelName = this.osTranslate(name);
          else if (key === "country") labelName = this.countryTranslate(name);
          else if (key === "hardware") labelName = this.platformTranslate(name);

          const dataMap = {};
          values.forEach((v) => {
            dataMap[v.data] = v.count;
          });

          series.push({
            name: labelName,
            data: sortedDates.map((d) => dataMap[d.raw] ?? 0),
          });
        });

        options = {
          chart: {
            type: this.selectedChartType,
            height: 300,
            fontFamily: "Vazir",
            toolbar: { show: false },
          },
          series: series,
          xaxis: {
            categories: formattedLabels,
            labels: { rotate: -45, style: { fontSize: "10px" } },
          },
          dataLabels: { enabled: this.lableToggler },
          stroke: { curve: "smooth", width: 3 },
          tooltip: { x: { show: true } },
        };
      }

      const chart = new ApexCharts(element, options);
      await chart.render();
      this.$set(this.charts, key, chart);
    },

    destroyChart(key) {
      if (this.charts[key]) {
        this.charts[key].destroy();
        delete this.charts[key];
      }
    },

    async updateActiveCharts() {
      const activeItems = this.statCards.filter((i) => i.active);
      for (const item of activeItems) {
        await this.loadSingleChart(item);
      }
    },
    formatDateLabel(dateStr) {
      if (!dateStr) return "";
      return moment(dateStr, "YYYY-MM-DD").format("jMM/jDD");
    },
    async showAllCharts() {
      this.loading = true;
      for (const item of this.statCards) {
        if (!item.active) {
          item.active = true;
          await this.loadSingleChart(item);
          this.mobileChartsExpanded =true;

        }
      }
      this.loading = false;
    },
    generateNormalOptions(dataType, dataObject) {
      return {
        chart: {
          type: this.selectedChartType,
          height: 250,
          fontFamily: "Vazir",
        },
        series: this.processSeries(dataType, dataObject),
        xaxis: { categories: this.processLabels(dataObject) },
        dataLabels: { enabled: this.lableToggler },
      };
    },

    generateRadialOptions(dataType, dataObject) {
      // منطق مشابه radialChart قبلی شما
      return {
        chart: {
          type: this.selectedChartType,
          height: 250,
          fontFamily: "Vazir",
        },
        labels: Object.keys(dataObject).map((k) =>
          this.translateValue(dataType, k),
        ),
        series: Object.values(dataObject).map((arr) =>
          arr.reduce((a, b) => a + b.count, 0),
        ),
        dataLabels: { enabled: this.lableToggler },
      };
    },

    translateValue(type, val) {
      if (type === "os") return this.osTranslate(val);
      if (type === "country") return this.countryTranslate(val);
      if (type === "hardware") return this.platformTranslate(val);
      return val;
    },
    translate(key) {
      return (
        {
          hardware: "سخت‌افزار",
          os: "سیستم‌عامل",
          osv: "ورژن سیستم‌عامل",
          browser: "مرورگر",
          browser_version: "ورژن مرورگر",
          country: "کشور",
          ip: "ای‌پی",
        }[key] ?? "-"
      );
    },
    countryTranslate(input) {
      let arr = [
        { AF: "افغانستان" },
        { AX: "جزایر آلند" },
        { AL: "آلبانی" },
        { DZ: "الجزایر" },
        { AS: "ساموآی آمریکایی" },
        { AD: "آندورا" },
        { AO: "آنگولا" },
        { AI: "آنگویلا" },
        { AQ: "قطب جنوب" },
        { AG: "آنتیگوا و باربودا" },
        { AR: "آرژانتین" },
        { AM: "ارمنستان" },
        { AW: "آروبا" },
        { AU: "استرالیا" },
        { AT: "اتریش" },
        { AZ: "آذربایجان" },
        { BS: "باهاما" },
        { BH: "بحرین" },
        { BD: "بنگلادش" },
        { BB: "باربادوس" },
        { BY: "بلاروس" },
        { BE: "بلژیک" },
        { BZ: "بلیز" },
        { BJ: "بنین" },
        { BM: "برمودا" },
        { BT: "بوتان" },
        { BO: "بولیوی" },
        { BA: "بوسنی و هرزگوین" },
        { BW: "بوتسوانا" },
        { BV: "جزیره Bouvet (Bouvetoya)" },
        { BR: "برزیل" },
        { IO: "منطقه اقیانوس هند بریتانیا (مجمع الجزایر چاگوس)" },
        { VG: "جزایر ویرجین بریتانیا" },
        { BN: "برونئی دارالسلام" },
        { BG: "بلغارستان" },
        { BF: "بورکینافاسو" },
        { BI: "بوروندی" },
        { KH: "کامبوج" },
        { CM: "کامرون" },
        { CA: "کانادا" },
        { CV: "کیپ ورد" },
        { KY: "جزایر کیمن" },
        { CF: "جمهوری آفریقای مرکزی" },
        { TD: "چاد" },
        { CL: "شیلی" },
        { CN: "چین" },
        { CX: "جزیره کریسمس" },
        { CC: "جزایر کوکوس (کیلینگ)" },
        { CO: "کلمبیا" },
        { KM: "کومور" },
        { CD: "کنگو" },
        { CG: "کنگو" },
        { CK: "جزایر کوک" },
        { CR: "کاستاریکا" },
        { CI: "Cote d'Ivoire" },
        { HR: "کرواسی" },
        { CU: "کوبا" },
        { CY: "قبرس" },
        { CZ: "جمهوری چک" },
        { DK: "دانمارک" },
        { DJ: "جیبوتی" },
        { DM: "دومینیکا" },
        { DO: "جمهوری دومینیکن" },
        { EC: "اکوادور" },
        { EG: "مصر" },
        { SV: "السالوادور" },
        { GQ: "گیینه استوایی" },
        { ER: "اریتره" },
        { EE: "استونی" },
        { ET: "اتیوپی" },
        { FO: "جزایر فارو" },
        { FK: "جزایر فالکلند (مالویناس)" },
        { FJ: "فیجی جزایر فیجی" },
        { FI: "فنلاند" },
        { FR: "فرانسه، جمهوری فرانسه" },
        { GF: "گویان فرانسه" },
        { PF: "پلی‌نزی فرانسه" },
        { TF: "سرزمین های جنوبی فرانسه" },
        { GA: "گابن" },
        { GM: "گامبیا" },
        { GE: "گرجستان" },
        { DE: "آلمان" },
        { GH: "غنا" },
        { GI: "جبل الطارق" },
        { GR: "یونان" },
        { GL: "گرینلند" },
        { GD: "گرنادا" },
        { GP: "گوادلوپ" },
        { GU: "گوام" },
        { GT: "گواتمالا" },
        { GG: "گرنزی" },
        { GN: "گینه" },
        { GW: "گینه بیسائو" },
        { GY: "گویان" },
        { HT: "هائیتی" },
        { HM: "جزیره هرد و جزایر مک دونالد" },
        { VA: "سریر مقدس (ایالت شهر واتیکان)" },
        { HN: "هندوراس" },
        { HK: "هنگ کنگ" },
        { HU: "مجارستان" },
        { IS: "ایسلند" },
        { IN: "هند" },
        { ID: "اندونزی" },
        { IR: "ایران" },
        { IQ: "عراق" },
        { IE: "ایرلند" },
        { IM: "جزیره انسان" },
        { IL: "اسرائیل" },
        { IT: "ایتالیا" },
        { JM: "جامائیکا" },
        { JP: "ژاپن" },
        { JE: "جرسی" },
        { JO: "اردن" },
        { KZ: "قزاقستان" },
        { KE: "کنیا" },
        { KI: "کیریباتی" },
        { KP: "کره" },
        { KR: "کره" },
        { KW: "کویت" },
        { KG: "جمهوری قرقیزستان" },
        { LA: "لائو" },
        { LV: "لتونی" },
        { LB: "لبنان" },
        { LS: "لسوتو" },
        { LR: "لیبری" },
        { LY: "جمهریای عربی لیبی" },
        { LI: "لیختن اشتاین" },
        { LT: "لیتوانی" },
        { LU: "لوکزامبورگ" },
        { MO: "ماکائو" },
        { MK: "مقدونیه" },
        { MG: "ماداگاسکار" },
        { MW: "مالاوی" },
        { MY: "مالزی" },
        { MV: "مالدیو" },
        { ML: "مالی" },
        { MT: "مالتا" },
        { MH: "جزایر مارشال" },
        { MQ: "مارتینیک" },
        { MR: "موریتانیا" },
        { MU: "موریس" },
        { YT: "مایوته" },
        { MX: "مکزیک" },
        { FM: "میکرونزی" },
        { MD: "مولداوی" },
        { MC: "موناکو" },
        { MN: "مغولستان" },
        { ME: "مونته نگرو" },
        { MS: "Montserrat" },
        { MA: "مراکش" },
        { MZ: "موزامبیک" },
        { MM: "میانمار" },
        { NA: "نامیبیا" },
        { NR: "نائورو" },
        { NP: "نپال" },
        { AN: "آنتیل هلند" },
        { NL: "هلند" },
        { NC: "کالدونیای جدید" },
        { NZ: "نیوزیلند" },
        { NI: "نیکاراگوئه" },
        { NE: "نیجر" },
        { NG: "نیجریه" },
        { NU: "Niue" },
        { NF: "جزیره نورفولک" },
        { MP: "جزایر ماریانای شمالی" },
        { NO: "نروژ" },
        { OM: "عمان" },
        { PK: "پاکستان" },
        { PW: "پالائو" },
        { PS: "سرزمین فلسطین" },
        { PA: "پاناما" },
        { PG: "پاپوآ گینه نو" },
        { PY: "پاراگوئه" },
        { PE: "پرو" },
        { PH: "فیلیپین" },
        { PN: "جزایر پیتکرن" },
        { PL: "لهستان" },
        { PT: "پرتغال، جمهوری پرتغال" },
        { PR: "پورتوریکو" },
        { QA: "قطر" },
        { RE: "اتحاد مجدد" },
        { RO: "رومانی" },
        { RU: "فدراسیون روسیه" },
        { RW: "روآندا" },
        { BL: "سنت بارتلمی" },
        { SH: "سنت هلنا" },
        { KN: "سنت کیتس و نویس" },
        { LC: "سنت لوسیا" },
        { MF: "سنت مارتین" },
        { PM: "سنت پیر و میکلون" },
        { VC: "سنت وینسنت و گرنادین ها" },
        { WS: "ساموآ" },
        { SM: "سان مارینو" },
        { ST: "Sao Tome and Principe" },
        { SA: "عربستان سعودی" },
        { SN: "سنگال" },
        { RS: "صربستان" },
        { SC: "سیشل" },
        { SL: "سیرا لئون" },
        { SG: "سنگاپور" },
        { SK: "اسلواکی (جمهوری اسلواکی)" },
        { SI: "اسلوونی" },
        { SB: "جزایر سلیمان" },
        { SO: "سومالی، جمهوری سومالی" },
        { ZA: "آفریقای جنوبی" },
        { GS: "گرجستان جنوبی و جزایر ساندویچ جنوبی" },
        { ES: "اسپانیا" },
        { LK: "سری لانکا" },
        { SD: "سودان" },
        { SR: "سورینام" },
        { SJ: "جزایر سوالبارد و یان ماین" },
        { SZ: "سوازیلند" },
        { SE: "سوئد" },
        { CH: "سوئیس، کنفدراسیون سوئیس" },
        { SY: "جمهوری عربی سوریه" },
        { TW: "تایوان" },
        { TJ: "تاجیکستان" },
        { TZ: "تانزانیا" },
        { TH: "تایلند" },
        { TL: "تیمور شرقی" },
        { TG: "توگو" },
        { TK: "توکلائو" },
        { TO: "تونگا" },
        { TT: "ترینیداد و توباگو" },
        { TN: "تونس" },
        { TR: "ترکیه" },
        { TM: "ترکمنستان" },
        { TC: "جزایر تورکس و کایکوس" },
        { TV: "Tuvalu" },
        { UG: "اوگاندا" },
        { UA: "اوکراین" },
        { AE: "امارات متحده عربی" },
        { GB: "بریتانیا" },
        { US: "ایالات متحده آمریکا" },
        { UM: "جزایر کوچک دورافتاده ایالات متحده" },
        { VI: "جزایر ویرجین ایالات متحده" },
        { UY: "اروگوئه، جمهوری شرقی" },
        { UZ: "ازبکستان" },
        { VU: "وانواتو" },
        { VE: "ونزوئلا" },
        { VN: "ویتنام" },
        { WF: "والیس و فوتونا" },
        { EH: "صحرای غربی" },
        { YE: "یمن" },
        { ZM: "زامبیا" },
        { ZW: "زیمبابوه" },
      ];
      let obj = arr.find((item) => item[input]);
      return !!obj ? obj[input] : "متفرقه";
    },
    osTranslate(input) {
      let arr = [
        { windows: "ویندوز" },
        { androidos: "اندروید" },
        { ios: "iOS" },
        { linux: "لینوکس" },
        { ubuntu: "اوبونتو" },
        { "os x": "مک" },
      ];
      let obj = arr.find((item) => item[input.toLowerCase()]);
      return !!obj ? obj[input.toLowerCase()] : "متفرقه";
    },
    platformTranslate(input) {
      let arr = [
        { desktop: "کامپیوتر" },
        { mobile: "موبایل" },
        { tablet: "تبلت" },
      ];
      let obj = arr.find((item) => item[input.toLowerCase()]);
      return !!obj ? obj[input.toLowerCase()] : "متفرقه";
    },
  },
};
</script>

<style scoped>
.max-width-200 {
  max-width: 200px;
}
.v-card {
  transition: all 0.3s ease;
}
</style>
